// POST API allows for triggering of POST requests
import { useEffect, useState } from 'react';
import request from 'superagent';

// Post API allows for triggering post on demand
export default function usePostApi(url) {
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [postData, setPostData] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      setIsError(false);
      setIsLoading(true);
      try {
        const result = await request.post(url).send(postData);
        setData(result.body);
      } catch (error) {
        setIsError(error);
      }
      setPostData(null);
      setIsLoading(false);
    };
    // first time, we don't do no fetching
    if (postData) fetchData();
  }, [postData]);
  return [{ data, isLoading, isError }, setPostData];
}



// WEBPACK FOOTER //
// ./src/utils/usePostApi.js